<template>
<div class="calc_rating">
  <div class="rating" @click="openDialog">
    <v-rating
      :value="values"
      color="yellow darken-3"
      background-color="grey darken-1"
      empty-icon="$ratingFull"
      half-increments
      hover
      class='rating_star'
    />
  </div>
</div>
</template>
<script>
export default {
  name: 'calc_rating',
  data:()=>({
    dialog: false,
    comment: '',
    rate: null,
  }),
  props:{
    value: {type: Number, default: 3},
    bank_id: {type: Number, default: null},
    product_id: {type: Number, default: null},
  },
  computed:{
    values:{
      get(){return this.value},
      set(val){this.$emit('input',val)}
    },
  },
  methods:{
    async init(){
      if(this.$store.getters.ratingConfig.length == 0){
        await this.$store.dispatch('GET_RATING_CONFIG')
      }
      this.rate = Array.from(this.$store.getters.ratingConfig)
    },
    async openDialog(){
      await this.init()
      this.$emit('closeDialog')
      this.$store.commit('setBankId',this.bank_id)
      this.$store.commit('setProductId',this.product_id)
      this.$router.push('/rating/userbank')
    },
  },
}
</script>
<style lang="sass" scoped>
@media (min-width: 1900px)
  .calc_rating
    transform: scale(1)

@media (min-width: 1380px)
  .calc_rating
    transform: scale(0.95)

@media (max-width: 1380px)
  .calc_rating
    transform: scale(0.85)


.rating
  width: 100%
  height: 100%
  cursor: pointer
  position: relative
  z-index: 1
  .rating_star
    z-index: -1
  &::after
    content: ''
    position: absolute
    top: 0px
    left: 0px
    right: 0px
    bottom: 0px
    width: 100%
    height: 100%
</style>
